var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-18134.443-18878.7l30.068,21.689-30.068,21.725Z","transform":"translate(18134.443 18878.695)"}));
}

Play.defaultProps = {"focusable":"false","width":"30.068","height":"43.414","viewBox":"0 0 30.068 43.414"};

module.exports = Play;

Play.default = Play;
